module.exports = __webpack_public_path__ + "static/media/line_logo.8a3bc1da.png";